import React, { useEffect, useState } from "react";
import { RefreshCw, Trash2 } from "lucide-react";
import { api } from "../../lib/api";

export default function Enquiries() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  async function load() {
    setLoading(true); setError("");
    try { const response = await api.enquiries.list(); setItems(Array.isArray(response.data) ? response.data : []); }
    catch (err) { setError(err.message); }
    finally { setLoading(false); }
  }

  useEffect(() => { load(); }, []);

  async function changeStatus(id, status) {
    try { await api.enquiries.status(id, status); setItems((current) => current.map((item) => item._id === id ? { ...item, status } : item)); }
    catch (err) { setError(err.message); }
  }

  async function remove(id) {
    if (!window.confirm("Delete this enquiry?")) return;
    try { await api.enquiries.remove(id); setItems((current) => current.filter((item) => item._id !== id)); }
    catch (err) { setError(err.message); }
  }

  return <section className="admin-page"><div className="admin-page-head"><div><h2>Enquiries</h2><p>View and manage website enquiries.</p></div><button className="admin-secondary" onClick={load}><RefreshCw size={16} /> Refresh</button></div>{error && <div className="admin-alert error">{error}</div>}<div className="admin-card">{loading ? <div className="admin-empty"><RefreshCw className="spin" /> Loading...</div> : items.length === 0 ? <div className="admin-empty">No enquiries received yet.</div> : <div className="admin-table-wrap"><table className="admin-table"><thead><tr><th>Name</th><th>Contact</th><th>Subject</th><th>Message</th><th>Date</th><th>Status</th><th>Action</th></tr></thead><tbody>{items.map((item) => <tr key={item._id}><td><strong>{item.fullName}</strong><br/><small>{item.source}</small></td><td>{item.phone}<br/><small>{item.email}</small></td><td>{item.subject}{item.className ? <><br/><small>Class: {item.className}</small></> : null}</td><td className="admin-message-cell">{item.message || "—"}</td><td>{new Date(item.createdAt).toLocaleString()}</td><td><select className="admin-status-select" value={item.status} onChange={(e) => changeStatus(item._id, e.target.value)}><option value="new">New</option><option value="contacted">Contacted</option><option value="closed">Closed</option></select></td><td><button className="admin-delete-btn" onClick={() => remove(item._id)}><Trash2 size={16} /></button></td></tr>)}</tbody></table></div>}</div></section>;
}
